import styled from "styled-components";

export const AboutStyle = styled.main`
`;


